/**
 * Brand fonts on the Live Gallery (PB-10474, LG-01). The payload's `brandFonts` (K22) has a heading and a body
 * role. Each role loads under its own alias, so a catalog family never clashes with a font installed on the guest's
 * device.
 *
 * `fallbackStack` is a CSS variable that `src/styles/components/general.styl` sets on `:root` from
 * `title-font-stack` / `body-font-stack`, so today's stacks live only in `fiesta-variables.styl`.
 */
export const BRAND_FONT_ROLES = Object.freeze({
  heading: Object.freeze({
    alias: 'LG Brand Heading',
    cssVariable: '--lg-brand-heading-font',
    fallbackStack: 'var(--lg-title-font-stack)',
  }),
  body: Object.freeze({
    alias: 'LG Brand Body',
    cssVariable: '--lg-brand-body-font',
    fallbackStack: 'var(--lg-body-font-stack)',
  }),
});

// `FontFamily.regularUrl` and `FontFamily.boldUrl` (K21) load as these weights.
export const BRAND_FONT_WEIGHTS = Object.freeze({
  regular: '400',
  bold: '700',
});
